import React, { Component } from 'react';
import { toast } from 'react-toastify';

import HeaderNav from '../HeaderNav';
import { canWriteAsAdmin } from '../../abilities';

export default function AdminPageHOC(WrappedComponent) {
  return class AdminPage extends Component {
    constructor() {
      super();
      this.state = {};
    }
    componentWillMount() {
      this.checkAdmin();
    }
    checkAdmin() {
      const { user, history } = this.props;
      if(!user.admin) {
        history.push('/');
        toast.error('Not authorized');
      }
    }
    componentDidMount() {
    }
    componentWillUnmount() {
    }
    componentDidUpdate(prevProps, prevState) {
    }
    render() {
      const { user } = this.props;
      const canWrite = canWriteAsAdmin(user);
      return !!user.admin && (
        <div>
          <HeaderNav {...{ ...this.props }} admin />
          <WrappedComponent {...{
            ...this.props,
            canWrite,
          }}
          />
        </div>
      );
    }
  };
}
